import { LoginTypes, ForgotPasswordTypes, ResetPasswordTypes } from "../../shared/interface/types";
import Api from "../../network/axiosClients";
import { AxiosResponse } from "axios";

export const LoginApi = async (data: LoginTypes): Promise<AxiosResponse> => {
  return Api.post("users/login", data);
};

export const ForgotPasswordApi = async (data: ForgotPasswordTypes): Promise<AxiosResponse> => {
  return Api.post("users/forgot-password/otp", data);
};

export const ResetPasswordApi = async (data: ResetPasswordTypes): Promise<AxiosResponse> => {
  return Api.post("users/reset-password", data);
};

export const getUserIdentity = async (): Promise<AxiosResponse> => {
  return Api.get("users/me");
};

export const userLogout = async (): Promise<AxiosResponse> => {
  return Api.post("users/logout");
};
